import gsap from 'gsap';

gsap.defaults({
  duration: 0.2,
  ease: 'power3.inOut',
});

export default function searchBox(renderOptions, isFirstRender) {
  const { query, refine, clear, isSearchStalled, widgetParams } = renderOptions;

  const container = document.querySelector(widgetParams.container);
  const loadingContainer = document.querySelector(widgetParams.loadingContainer);

  if (isFirstRender) {
    const input = document.createElement('input');
    const label = document.createElement('label');
    input.classList.add('search-box__input');
    label.classList.add('visually-hidden');
    input.setAttribute('id', 'search');
    label.setAttribute('for', 'search');
    label.innerText = 'Search';

    const button = document.createElement('button');
    const buttonContent = document.createElement('span');
    button.appendChild(buttonContent);
    button.setAttribute('aria-label', 'Clear Search');
    button.classList.add('search-box__clear');
    buttonContent.classList.add('search-box__clear__icon');

    input.placeholder = widgetParams.prompt;
    input.autofocus = true;
    input.addEventListener('input', event => {
      refine(event.target.value);
      event.target.value.length < 1
        ? button.classList.remove('clear-is-visible')
        : button.classList.add('clear-is-visible');
    });

    button.addEventListener('click', () => {
      clear();
      button.classList.remove('clear-is-visible');
    });

    container.appendChild(label);
    container.appendChild(input);
    container.appendChild(button);
  }

  isSearchStalled
    ? () => {
      gsap.to('.search__hits', { autoAlpha: 0 });
      loadingContainer.innerHTML = `
    <div class="search__loading__content">
      <h4 class="loading__h">Loading</h4>
      <div class="loading__indicator">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
    `;
    }
    : () => {
      gsap.to('.search__hits', { autoAlpha: 1 });
      loadingContainer.innerHTML = '';
    };

  container.querySelector('input').value = query;
}
